// src/data/planning/tbmProgram.js

/**
 * REHBER360 - TBM / BAĞIMLILIKLA MÜCADELE PROGRAM TAKVİMİ
 *
 * ÖNEMLİ:
 * - Faaliyet isimleri burada tutulmaz.
 * - Faaliyetlerin resmi karşılıkları officialActivityCatalog.js içindedir.
 * - Bu dosya yalnızca eğitim yılına göre:
 *   hangi faaliyet,
 *   hangi hedef kitle,
 *   hangi okul/sınıf düzeyi,
 *   hangi zaman aralığında uygulanacak
 *   bilgisini tutar.
 *
 * 2025-2026 verisi referans amacıyla saklanmaktadır.
 * 2026-2027 için kademe-modül kapsamı güncel MEB TBM içeriklerine göre aktiftir.
 * Ay/hafta ataması resmî sabit takvim olarak yorumlanmaz;
 * Rehber360 scheduler tarafından "balanced" kuralıyla yapılır.
 */


export const TBM_PROGRAM_VERSION = "TBM-PROGRAM-V1";


export const TBM_PROGRAMS = {

  // =========================================================
  // 2025-2026
  // SADECE REFERANS PROFİLİ
  // =========================================================

  "2025-2026": {

    academicYear: "2025-2026",

    status: "reference",

    activeForPlanGeneration: false,

    source: {
      system: "E_REHBERLIK_GUIDE",
      document: "Okul Rehberlik Programı Hazırlama Kılavuzu",
      year: "2025-2026"
    },

    rules: [

      // -----------------------------------------------------
      // ÖĞRENCİ
      // -----------------------------------------------------

      {
        id: "tbm_2025_student_tobacco",

        activityId: "tbm_student_tobacco",

        audience: "student",

        schoolLevels: [
          "primary",
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_student_alcohol",

        activityId: "tbm_student_alcohol",

        audience: "student",

        schoolLevels: [
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_student_substance",

        activityId: "tbm_student_substance",

        audience: "student",

        schoolLevels: [
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_student_gambling",

        activityId: "tbm_student_gambling",

        audience: "student",

        schoolLevels: [
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_student_technology",

        activityId: "tbm_student_technology",

        audience: "student",

        schoolLevels: [
          "primary",
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      // -----------------------------------------------------
      // VELİ
      // -----------------------------------------------------

      {
        id: "tbm_2025_parent_tobacco",

        activityId: "tbm_parent_tobacco",

        audience: "parent",

        schoolLevels: [
          "primary",
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_parent_gambling",

        activityId: "tbm_parent_gambling",

        audience: "parent",

        schoolLevels: [
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_parent_conscious_technology",

        activityId: "tbm_parent_conscious_technology",

        audience: "parent",

        schoolLevels: [
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      // -----------------------------------------------------
      // ÖĞRETMEN
      // -----------------------------------------------------

      {
        id: "tbm_2025_teacher_tobacco",

        activityId: "tbm_teacher_tobacco",

        audience: "teacher",

        schoolLevels: [
          "primary",
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_teacher_gambling",

        activityId: "tbm_teacher_gambling",

        audience: "teacher",

        schoolLevels: [
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      },

      {
        id: "tbm_2025_teacher_substance",

        activityId: "tbm_teacher_substance",

        audience: "teacher",

        schoolLevels: [
          "high_school",
          "vocational_high_school"
        ],

        timing: {
          type: "official_schedule"
        }
      }

    ]
  },


  // =========================================================
  // 2026-2027
  // KADEMEYE GÖRE GÜNCEL TBM ÖĞRENCİ MODÜLLERİ
  //
  // ÖNEMLİ:
  // - Buradaki "balanced" resmî bir aylık uygulama takvimi değildir.
  // - Rehber360 bu modülleri Ekim-Nisan arasına dengeli dağıtır.
  // - Faaliyet adları yine officialActivityCatalog.js içinden çözülür.
  // =========================================================

  "2026-2027": {

    academicYear: "2026-2027",

    status: "active",

    activeForPlanGeneration: true,

    source: {
      system: "MEB_ORGM_TBM",
      document:
        "Türkiye Bağımlılıkla Mücadele (TBM) Programı",
      scope:
        "Kademe bazlı öğrenci modül kapsamı"
    },

    rules: [

      {
        id: "tbm_2026_student_healthy_life",

        activityId:
          "tbm_student_healthy_life",

        audience: "student",

        schoolLevels: [
          "preschool",
          "primary",
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        activityTypeId: "seminar",

        selectionMode: "locked",

        timing: {
          type: "balanced"
        },

        order: 220
      },

      {
        id: "tbm_2026_student_technology",

        activityId:
          "tbm_student_technology",

        audience: "student",

        schoolLevels: [
          "preschool",
          "primary",
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        activityTypeId: "seminar",

        selectionMode: "locked",

        timing: {
          type: "balanced"
        },

        order: 230
      },

      {
        id: "tbm_2026_student_tobacco",

        activityId:
          "tbm_student_tobacco",

        audience: "student",

        schoolLevels: [
          "primary",
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        activityTypeId: "seminar",

        selectionMode: "locked",

        timing: {
          type: "balanced"
        },

        order: 240
      },

      {
        id: "tbm_2026_student_gambling",

        activityId:
          "tbm_student_gambling",

        audience: "student",

        schoolLevels: [
          "middle_school",
          "high_school",
          "vocational_high_school"
        ],

        activityTypeId: "seminar",

        selectionMode: "locked",

        timing: {
          type: "balanced"
        },

        order: 250
      },

      {
        id: "tbm_2026_student_alcohol",

        activityId:
          "tbm_student_alcohol",

        audience: "student",

        schoolLevels: [
          "high_school",
          "vocational_high_school"
        ],

        activityTypeId: "seminar",

        selectionMode: "locked",

        timing: {
          type: "balanced"
        },

        order: 260
      },

      {
        id: "tbm_2026_student_substance",

        activityId:
          "tbm_student_substance",

        audience: "student",

        schoolLevels: [
          "high_school",
          "vocational_high_school"
        ],

        activityTypeId: "seminar",

        selectionMode: "locked",

        timing: {
          type: "balanced"
        },

        order: 270
      }

    ]
  }

};


// =========================================================
// YARDIMCI FONKSİYONLAR
// =========================================================

export const getTbmProgram = (academicYear) => {
  return TBM_PROGRAMS[academicYear] || null;
};


export const getActiveTbmProgram = (academicYear) => {
  const program = TBM_PROGRAMS[academicYear];

  if (!program?.activeForPlanGeneration) {
    return null;
  }

  return program;
};


export const getTbmRulesForSchoolLevel = (
  academicYear,
  schoolLevel
) => {

  const program = getActiveTbmProgram(academicYear);

  if (!program) return [];

  return program.rules.filter(rule =>
    rule.schoolLevels.includes(schoolLevel)
  );
};